const styles = (theme) => ({
	container: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		padding: "16px",
		marginTop: "16px",
	},
	cabecalho: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		gap: 1,
		marginBottom: "12px",
	},
	tituloGrupo: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
	},
	titulo: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},
	statusCelula: {
		display: "flex",
		alignItems: "center",
		gap: 0.5,
	},
	resultadoAtualizacao: {
		display: "flex",
		flexDirection: "column",
		gap: 0.5,
	},
	linhaChip: {
		display: "flex",
		alignItems: "center",
		gap: 0.5,
	},
	motivoEvento: {
		color: theme.palette.chip.colorText.critical,
	},
	buscaField: {
		width: "260px",
		"@media (max-width: 600px)": {
			width: "100%",
		},
	},
	paper: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
		overflow: "hidden",
	},
	gridContainer: {
		width: "100%",
		height: "380px",
		overflow: "auto",
	},
	chip: {
		fontWeight: 600,
		height: "20px",
	},
	semResultado: {
		color: theme.palette.text.secondary,
		textAlign: "center",
		padding: "16px",
	},
});

export default styles;
